import { useTranslation } from "next-i18next";
import { useCallback, useRef } from "react";

import { getRandomInt } from "../utils";

interface IClap {
  likes: number;
  onClick: () => void;
}

const Clap = ({ likes, onClick }: IClap) => {
  const { t } = useTranslation();
  const clapBlock = useRef<HTMLDivElement>(null);
  const clapAnimationBlock = useRef<HTMLDivElement>(null);

  const memoizedRandomInt = useCallback(() => {
    return getRandomInt(720);
  }, []);

  const handleClick = () => {
    onClick();
    clapBlock?.current?.classList.add("is-clapped", "is-active");

    if (clapAnimationBlock.current) {
      clapAnimationBlock.current.style.transform = `rotate(${memoizedRandomInt()}deg)`;
    }

    setTimeout(() => {
      clapBlock?.current?.classList.remove("is-clapped");
      if (clapAnimationBlock.current) {
        clapAnimationBlock.current.style.transform = `rotate(0deg)`;
      }
    }, 400);
  };

  return (
    <div className="clap" onClick={handleClick} ref={clapBlock}>
      <span className="clap__bubble">+1</span>
      <button className="btn btn-shadow size-s clap__btn">
        <span className="icon icon-clap clap__icon" />
        <strong className="clap__count">{likes}</strong>
        <em className="clap__text">-&nbsp;{t("Clap")}</em>
      </button>
      <div className="clap__animation" ref={clapAnimationBlock}>
        <div className="clap__animation-block">
          <span className="clap__animation-item" />
        </div>
        <div className="clap__animation-block">
          <span className="clap__animation-item" />
        </div>
      </div>
    </div>
  );
};

export default Clap;
